export const ITEM_LIST_TITLE = `יתרונות צ'ק בטוח של WeCheck`

export const DISCLAIMER = `כפי שאתם רואים, לצ'ק בטוח, הערבות לשכירות של Wecheck, יש הרבה מאוד יתרונות וכל זה עבור תשלום חודשי נמוך כתלות ברמת הסיכון של הדייר. יתרה מזאת הדייר עצמו יכול לשלם על הערבות או להשתתף חלקית בעלות.`
